export default "__VITE_ASSET__Bs7xRDzk__"